export function getSortedOptions(isSorted, isGrouped, labelKey, options, handleSort) {
    var sortedOptions;
    // default sorts options alphabetically by option label
    var defaultSort = function (options) {
        return options.sort(function (option1, option2) {
            return option1[labelKey] > option2[labelKey] ? 1 : -1;
        });
    };
    //  single options[] logic for sorting
    if (isSorted && !isGrouped) {
        sortedOptions =
            typeof handleSort === 'function'
                ? handleSort(options)
                : defaultSort(options);
    }
    // multi group logic for sorting
    if (isSorted && isGrouped) {
        var groupOptions = options;
        groupOptions = groupOptions.map(function (group) {
            return {
                label: group.label,
                options: typeof handleSort === 'function'
                    ? handleSort(group.options)
                    : defaultSort(group.options)
            };
        });
        sortedOptions = groupOptions;
    }
    return sortedOptions;
}
//# sourceMappingURL=optionSorting.js.map